import { render, staticRenderFns } from "./RespostaDetalhesHistorico.vue?vue&type=template&id=0fac704b&"
import script from "./RespostaDetalhesHistorico.vue?vue&type=script&lang=js&"
export * from "./RespostaDetalhesHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports